<template>
  <div v-if="from" class="event-date" :class="weight">
    <div v-if="approximate">
      {{ fromMonth }}
    </div>
    <div v-else-if="singleDay">
      <div v-if="toTime">
        <span>{{ fromDay }}</span
        ><span v-if="!justDate">, {{ fromTime }} - {{ toTime }}</span>
      </div>
      <div v-else>
        <span>{{ fromDay }}</span
        ><span v-if="!justDate">, {{ fromTime }}</span>
      </div>
    </div>
    <div v-else class="event-date">
      <div>
        <span>{{ fromDay }}</span
        ><span v-if="!justDate">, {{ fromTime }}</span> -
        <span>{{ toDay }}</span
        ><span v-if="!justDate">, {{ toTime }}</span>
      </div>
    </div>
  </div>
</template>
<script>

const dateOptions = { month: 'short', day: 'numeric' };
let timeOptions = { hour: '2-digit', minute: '2-digit' };
let lang = document.getElementsByTagName('html')[0].getAttribute('lang');
if (lang === 'en-GB') {
  lang = 'en-US';
  timeOptions = { hour12: false, hour: '2-digit', minute: '2-digit' };
}
export default {
  props: {
    from: {
      type: String,
      default: ''
    },
    to: {
      type: String,
      default: ''
    },
    justDate: Boolean,
    approximate: Boolean,
    weight: {
      type: String,
      default: ' -thin'
    }
  },
  data () {
    return {

    };
  },
  computed: {
    fromMonth () {
      if (!this.from) {
        return null;
      }
      return new Date(this.from).toLocaleDateString(lang, { year: 'numeric', month: 'short' });
    },
    fromDay () {
      if (!this.from) {
        return null;
      }
      return new Date(this.from).toLocaleDateString(lang, dateOptions);
    },
    toDay () {
      if (!this.to) {
        return null;
      }
      return new Date(this.to).toLocaleDateString(lang, dateOptions);
    },
    fromTime () {
      if (!this.from) {
        return null;
      }
      return new Date(this.from).toLocaleTimeString(lang, timeOptions);
    },
    toTime () {
      if (!this.to) {
        return null;
      }
      return new Date(this.to).toLocaleTimeString(lang, timeOptions);
    },
    singleDay () {
      if (!this.from) {
        return null;
      }
      if (!this.to) {
        return true;
      }
      return this.fromDay === this.toDay;
    }
  }
};
</script>
<style lang="scss">
.event-date {
  label {
    display: block;
    margin: 0;
  }
  &-multi {
    margin-bottom: 18px;
  }
}
</style>
